import React from "react";
import { connect } from "react-redux";
import { selectors as booksSelectors } from "../../../../redux/books";
import ExpiredBook from "../book/expired-book";
import { t } from "../../../core/translate";
import FlexibleBookGrid from "../bookviews/flexible-book-grid";

function ExpiredBooksGrid({ expiredIsbns, onHeaderClick }) {
  const headerText = t("recent-expired.recently-expired", "Expired");
  const pageTitle = t("library.library-category", "Library Category", {
    category: headerText
  });

  return (
    <FlexibleBookGrid
      headerText={headerText}
      pageTitle={pageTitle}
      onHeaderClick={onHeaderClick}
    >
      {expiredIsbns.map(isbn => (
        <ExpiredBook isbn={isbn} key={isbn} />
      ))}
    </FlexibleBookGrid>
  );
}

export default connect(state => ({
  expiredIsbns: booksSelectors.getAllExpiredIsbns(state)
}))(ExpiredBooksGrid);
